import {
  Button,
  Card,
  Checkbox,
  Chip,
  LinearProgress,
  ListItemText,
  Menu,
  MenuItem,
  Modal,
  Typography,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { FaFileExcel } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import toast, { LoaderIcon } from 'react-hot-toast';
import { fetchEventSource } from '@microsoft/fetch-event-source';
import axios from 'axios';
import FileInputDropZone from '../../../ui/FileInput/FileInputDropZone';
import { useEffect, useRef, useState } from 'react';
import GlobalSpinner from '../../../Components2/common/GlobalSpinner';
import LoadedDataFormExcel from './LoadedDataFormExcel';
import FiltersArtes from '../FiltersArtes';
import { Buscador } from '../../Pedido/Buscador';
import { handleChangeInputSearch, handleClearInput, handleKeyDown } from '../../../helpers/buscadorHelper';
import useGetGenerateExcelNumberPreview from './useGetGenerateExcelNumberPreview';
import FilterMenuExcel from './FilterMenuExcel';
import BreadcrumbCategories from '../../Categories/BreadcrumbCategories';
import { useAuth0 } from '@auth0/auth0-react';
const ArticlesExcelModal = () => {
  const { getAccessTokenSilently } = useAuth0();
  const fileInputRef = useRef(null);
  const isMountedRef = useRef(true);
  const [fileName, setFileName] = useState('');
  const [dataExcel, setDataExcel] = useState(null);
  const [isReadingFile, setIsReadingFile] = useState(false);
  const [isGeneratingFile, setIsGeneratingFile] = useState(false);
  const [readProgress, setReadProgress] = useState({ message: '', pct: 0 });
  const [importError, setImportError] = useState(null);

  const [search, setSearch] = useState(null);
  const [centerTypeSelected, setCenterTypeSelected] = useState('all');
  const [statusSelected, setStatusSelected] = useState('all');
  const [centerSelected, setCenterSelected] = useState(null);
  const [superIdCategory, setSuperIdCategory] = useState(null);
  const [categorySelected, setCategorySelected] = useState([]);
  const [withoutCategorySelected, setWithoutCategorySelected] = useState(false);
  const [issuesFilter, setIssuesFilter] = useState('all');

  const [exportOptions, setExportOptions] = useState({
    articles: true,
    formats: true,
    providers: true,
    embedImages: false,
  });

  const [templateMenuAnchor, setTemplateMenuAnchor] = useState(null);
  const [selectedTemplateFormat, setSelectedTemplateFormat] = useState('2');

  const handleOpenTemplateMenu = (e) => setTemplateMenuAnchor(e.currentTarget);
  const handleCloseTemplateMenu = () => setTemplateMenuAnchor(null);
  const handleSelectTemplateFormat = (format) => {
    setSelectedTemplateFormat(format);
    handleCloseTemplateMenu();
    handleClickExport(`template-${format}-empty`);
  };

  const { data, isLoading, isFetching } = useGetGenerateExcelNumberPreview({
    centerTypeSelected,
    statusSelected,
    search,
    centerSelected,
    issuesFilter,
    superIdCategory: superIdCategory?._id,

    withoutCategorySelected,
  });

  const handleResetCategories = () => {
    setCategorySelected([]);
    setSuperIdCategory(null);
  };

  const handleMoveBackCategory = (el) => {
    const index = categorySelected.findIndex((c) => c._id === el._id);
    const newCategorySelected = categorySelected.slice(0, index + 1);
    setCategorySelected(newCategorySelected);
    setSuperIdCategory({ _id: el._id, parentCategory: el.parentCategory });
  };

  const navigate = useNavigate();

  const handleCloseModal = () => {
    if (dataExcel === null && !isReadingFile && !isGeneratingFile) return navigate(`../`);

    // eslint-disable-next-line no-restricted-globals
    if (confirm('¿Quieres salir del proceso de importación? Los cambios no guardados se perderán.')) {
      navigate(`../`);
    }
  };

  const handleImportExcel = async (file) => {
    setIsReadingFile(true);
    setReadProgress({ message: 'Iniciando...', pct: 0 });

    const formData = new FormData();
    formData.append('file', file);
    const token = await getAccessTokenSilently();

    try {
      await fetchEventSource('/api/v1/excel/articles/read', {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
        onmessage(ev) {
          if (!isMountedRef.current) return;
          const data = JSON.parse(ev.data);
          if (ev.event === 'progress') {
            setReadProgress({ message: data.message, pct: data.pct });
          } else if (ev.event === 'done') {
            setReadProgress({ message: 'Completado', pct: 100 });
            setDataExcel(data.data);
            setIsReadingFile(false);
          } else if (ev.event === 'error') {
            throw new Error(data.message);
          }
        },
        onerror(err) {
          throw err;
        },
      });
    } catch (err) {
      if (!isMountedRef.current) return;
      if (fileInputRef.current) fileInputRef.current.value = '';
      setIsReadingFile(false);
      setImportError(err.message || 'Error al leer el Excel');
    }
  };

  const handleClickExport = async (type) => {
    const toastId = 'exporting-articles-excel';
    toast.loading('Exportando...', { id: toastId, duration: Infinity });
    setIsGeneratingFile(true);

    try {
      const token = await getAccessTokenSilently();
      const response = await axios.get('/api/v1/excel/articles', {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          centerTypeSelected,
          statusSelected,
          search,
          centerSelected,
          idCategory: superIdCategory?._id ?? null,
          type,
          exportOptions,
          issuesFilter,
          withoutCategorySelected,
        },
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(response.data);
      const a = document.createElement('a');
      a.href = url;
      const now = new Date();
      const dateStr = `${String(now.getDate()).padStart(2, '0')}_${String(now.getMonth() + 1).padStart(
        2,
        '0',
      )}_${now.getFullYear()}`;
      a.download = type.includes('empty') ? `plantilla_catalago_${dateStr}.xlsx` : `catalago_exportado_${dateStr}.xlsx`;

      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);

      toast.success('Exportado', { id: toastId, duration: 2000 });
    } catch (err) {
      console.error('Error al exportar', err);
      toast.error('Error al exportar', { id: toastId, duration: 2000 });
    } finally {
      setIsGeneratingFile(false);
    }
  };

  useEffect(() => {
    isMountedRef.current = true;
    toast.dismiss('reading-articles-excel');
    return () => {
      isMountedRef.current = false;
      toast.dismiss('reading-articles-excel');
    };
  }, []);

  useEffect(() => {
    const shouldWarn = dataExcel !== null || isReadingFile || isGeneratingFile;
    if (!shouldWarn) return;

    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [dataExcel, isReadingFile, isGeneratingFile]);

  return (
    <Modal onClose={handleCloseModal} open>
      <div className="articles-excel-container-modal">
        <Typography
          variant="h4"
          component="h2"
          align="center"
          sx={{
            fontWeight: 'bold',
            marginBottom: '1.5rem',
            backgroundColor: '#3C4145',
            color: 'white',
            paddingX: '5rem',
          }}
        >
          IMPORTAR/ EXPORTAR EXCEL
        </Typography>
        {!isReadingFile && !isGeneratingFile ? (
          <>
            {dataExcel === null ? (
              importError ? (
                <div className="excel-import-error">
                  <span className="excel-import-error-icon">⚠</span>
                  <Typography variant="h6" color="error" fontWeight="bold">
                    Error al procesar el archivo
                  </Typography>
                  <Typography variant="body2" align="center" sx={{ maxWidth: 480 }}>
                    {importError}
                  </Typography>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={() => {
                      setImportError(null);
                      setFileName('');
                    }}
                  >
                    Intentar con otro archivo
                  </Button>
                </div>
              ) : (
                <div className="articles-excel-content">
                  <div className="generate-excel-container">
                    <div className="articles-excel-content categories">
                      <FilterMenuExcel
                        search={search}
                        statusSelected={statusSelected}
                        centerTypeSelected={centerTypeSelected}
                        centerSelected={centerSelected}
                        superIdCategory={superIdCategory}
                        setSuperIdCategory={setSuperIdCategory}
                        categorySelected={categorySelected}
                        setCategorySelected={setCategorySelected}
                        withoutCategorySelected={withoutCategorySelected}
                        setWithoutCategorySelected={setWithoutCategorySelected}
                      />
                    </div>
                    <div className="articles-excel-content main">
                      <BreadcrumbCategories
                        categorySelected={categorySelected}
                        handleReset={handleResetCategories}
                        handleMoveBack={handleMoveBackCategory}
                      />
                      <div className="articles-excel-content-search">
                        <Buscador
                          label="Buscar por nombre, por código de ariba, por palabra clave..."
                          value={search}
                          width="85"
                          onChange={(e) => handleChangeInputSearch(e, setSearch)}
                          onKeyDown={(e) => handleKeyDown(e, setSearch)}
                          onClear={() => handleClearInput(setSearch)}
                        />
                      </div>
                      <FiltersArtes
                        valueCenter={centerSelected}
                        setValueCenter={setCenterSelected}
                        valueCenterType={centerTypeSelected}
                        setValueCenterType={setCenterTypeSelected}
                        valueStatus={statusSelected}
                        setValueStatus={setStatusSelected}
                        issuesFilter={issuesFilter}
                        setIssuesFilter={setIssuesFilter}
                        withValidation
                      />

                      <div className="articles-excel-cards-container">
                        <Card className="articles-excel-card">
                          <Checkbox
                            className="card-checkbox"
                            disabled={data?.data?.totalArtesFinales === 0 || isLoading || isFetching}
                            checked={exportOptions.articles}
                            onChange={(e) =>
                              setExportOptions({
                                ...exportOptions,
                                articles: e.target.checked,
                              })
                            }
                          />
                          <h1 className={data?.data?.totalArtesFinales !== 0 ? 'created' : ''}>
                            {!isLoading && !isFetching ? (
                              data?.data?.totalArtesFinales
                            ) : (
                              <LoaderIcon
                                style={{
                                  height: '1.2rem',
                                  width: '1.2rem',
                                }}
                              />
                            )}
                          </h1>
                          <span>Articulos</span>
                        </Card>
                        <Card className="articles-excel-card">
                          <Checkbox
                            className="card-checkbox"
                            disabled={data?.data?.totalFormats === 0 || isLoading || isFetching}
                            checked={exportOptions.formats}
                            onChange={(e) =>
                              setExportOptions({
                                ...exportOptions,
                                formats: e.target.checked,
                              })
                            }
                          />

                          <h1 className={data?.data?.totalFormats !== 0 ? 'created' : ''}>
                            {!isLoading && !isFetching ? (
                              data?.data?.totalFormats
                            ) : (
                              <LoaderIcon
                                style={{
                                  height: '1.2rem',
                                  width: '1.2rem',
                                }}
                              />
                            )}
                          </h1>
                          <span>Formatos</span>
                        </Card>
                        <Card className="articles-excel-card">
                          <Checkbox
                            disabled={data?.data?.totalProviderFormats === 0 || isLoading || isFetching}
                            className="card-checkbox"
                            checked={exportOptions.providers}
                            onChange={(e) =>
                              setExportOptions({
                                ...exportOptions,
                                providers: e.target.checked,
                              })
                            }
                          />

                          <h1 className={data?.data?.totalProviderFormats !== 0 ? 'created' : ''}>
                            {!isLoading && !isFetching ? (
                              data?.data?.totalProviderFormats
                            ) : (
                              <LoaderIcon
                                style={{
                                  height: '1.2rem',
                                  width: '1.2rem',
                                }}
                              />
                            )}
                          </h1>
                          <span>Proveedores</span>
                        </Card>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <Checkbox
                          size="small"
                          checked={exportOptions.embedImages}
                          onChange={(e) => setExportOptions({ ...exportOptions, embedImages: e.target.checked })}
                          id="embed-images-checkbox"
                        />
                        <label
                          htmlFor="embed-images-checkbox"
                          style={{ cursor: 'pointer', userSelect: 'none', fontSize: '0.875rem', marginBottom: '0' }}
                        >
                          Incluir imágenes embebidas
                        </label>
                      </div>
                      <Button
                        variant="contained"
                        color="success"
                        size="small"
                        startIcon={<FaFileExcel />}
                        onClick={() => handleClickExport(`template-1`)}
                        disabled={
                          isLoading ||
                          isFetching ||
                          data?.data?.totalArtesFinales === 0 ||
                          (exportOptions.articles === false &&
                            exportOptions.formats === false &&
                            exportOptions.providers === false)
                        }
                      >
                        EXPORTAR CATALOGO
                      </Button>
                    </div>
                  </div>

                  <hr className="separator" />

                  <FileInputDropZone
                    onFileSelect={handleImportExcel}
                    label="Arrastra y suelta la plantilla de Excel aquí"
                    forwardedRef={fileInputRef}
                    onSetFileName={(name) => setFileName(name)}
                  />
                  <Button
                    variant="contained"
                    color="success"
                    size="small"
                    startIcon={<FaFileExcel />}
                    endIcon={<ArrowDropDownIcon />}
                    onClick={handleOpenTemplateMenu}
                  >
                    DESCARGAR PLANTILLA
                  </Button>
                  <Menu
                    anchorEl={templateMenuAnchor}
                    open={Boolean(templateMenuAnchor)}
                    onClose={handleCloseTemplateMenu}
                  >
                    <MenuItem
                      selected={selectedTemplateFormat === '1'}
                      onClick={() => handleSelectTemplateFormat('1')}
                      sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, minWidth: 400 }}
                    >
                      <ListItemText
                        primary="Formato 1 — 3 pestañas: Artículos · Formatos · Proveedores"
                        secondary="cada fila corresponde a un artículo, formato o proveedor según corresponda"
                      />
                      <Chip label="Edición masiva" size="small" color="success" sx={{ mt: 0.5, flexShrink: 0 }} />
                    </MenuItem>
                    <MenuItem
                      selected={selectedTemplateFormat === '2'}
                      onClick={() => handleSelectTemplateFormat('2')}
                      sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, minWidth: 400 }}
                    >
                      <ListItemText
                        primary="Formato 2 — 1 pestaña: solo Artículos"
                        secondary="cada fila corresponde a un formato (aunque se repita la información del artículo)"
                      />
                      <Chip label="Alta de artículos" size="small" color="primary" sx={{ mt: 0.5, flexShrink: 0 }} />
                    </MenuItem>
                  </Menu>
                </div>
              )
            ) : (
              <LoadedDataFormExcel
                dataExcel={dataExcel}
                setDataExcel={setDataExcel}
                fileName={fileName}
                setFileName={setFileName}
              />
            )}
          </>
        ) : (
          <div className="loader-container-excel">
            {isReadingFile && (
              <>
                <h4>
                  Leyendo "<i>{fileName}</i>""
                </h4>
                <div
                  style={{
                    width: '100%',
                    maxWidth: 480,
                    height: '10rem',
                    paddingTop: '4rem ',
                  }}
                >
                  <LinearProgress
                    color="error"
                    variant="determinate"
                    value={readProgress.pct}
                    sx={{ height: 8, borderRadius: 4, mb: 1 }}
                  />
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.8rem', color: '#555' }}>
                    <span>{readProgress.message}</span>
                    <span>{readProgress.pct}%</span>
                  </div>
                </div>
              </>
            )}
            {isGeneratingFile && <div>Generando archivo excel, por favor espere...</div>}
            {isGeneratingFile && <GlobalSpinner />}
            <div style={{ fontSize: '0.8rem', color: '#888' }}>
              Este proceso puede tardar varios minutos según el tamaño del archivo.
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ArticlesExcelModal;
